import { datadogRum } from '@datadog/browser-rum';
import { StatusType, datadogLogs } from '@datadog/browser-logs';
import { Auth } from 'aws-amplify';

export function initialiseDatadog(): void {
  const defaultEnvironment = 'prod';
  const hostnameToEnvironmentMap: { [key: string]: string } = {
    'portal.manna.aero': defaultEnvironment,
    'portal-uat.manna.aero': 'uat',
    'portal-dev.manna.aero': 'dev',
    'localhost:3000': 'local'
  };
  datadogRum.init({
    applicationId: '9715d6e7-66a1-4d57-b7fd-59b901ecc7ae',
    clientToken: 'pubb0935dd1cfe6684b537d260852d38012',
    site: 'datadoghq.eu',
    service: 'manna-view',
    env: hostnameToEnvironmentMap[document.location.host] || defaultEnvironment,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sampleRate: 100,
    premiumSampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: 'allow'
  });
  datadogLogs.init({
    clientToken: 'pubb0935dd1cfe6684b537d260852d38012',
    site: 'datadoghq.eu',
    service: 'manna-view',
    env: hostnameToEnvironmentMap[document.location.host] || defaultEnvironment,
    forwardErrorsToLogs: true,
    sampleRate: 100
  });

  datadogRum.startSessionReplayRecording();
  Auth.currentUserInfo().then(data => {
    datadogRum.setUser({
      email: data?.username,
      id: data?.attributes?.sub
    });
  });
}

export function logToDatadog(
  message: string,
  data = {},
  level: StatusType = StatusType.info
) {
  try {
    datadogLogs.logger.log(message, data, level);
  } catch (error) {
    console.error('Error logging to datadog. Error:', error);
    console.info('original debug message:', message, data, level);
  }
}
